module.exports = __webpack_public_path__ + "img/olders.e93c659a.png";